import { ContentDisplayStyle, useMapContext, ViewType } from './Map.tsx';
import cn from '../utils/cn.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faMagnifyingGlass,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { ContentFormat } from '../api/api.ts';
import { useContext } from 'react';
import { LanguageContext } from '@/common/Language.tsx';

export default function PanelStoryContent({
  className,
}: {
  className: string;
}) {
  const { t } = useContext(LanguageContext);
  const { view } = useMapContext();

  if (!(view && view.type === ViewType.Story)) return <></>;

  return (
    <div
      className={cn(
        '-mx-[40px]',
        'py-[24px]',
        'px-[40px]',
        'overflow-y-auto',
        className
      )}
    >
      <h1>{t(view.project.name, view.project.nameDe)}</h1>
      {view.project.contentFormat !== ContentFormat.Html &&
        t(
          view.layer.layers[view.markerIndex].content,
          view.layer.layers[view.markerIndex].contentDe
        )
          .split('\n')
          .map((line, index) => <p key={index}>{line}</p>)}
      {view.project.contentFormat === ContentFormat.Html && (
        <div
          dangerouslySetInnerHTML={{
            __html: t(
              view.layer.layers[view.markerIndex].content,
              view.layer.layers[view.markerIndex].contentDe
            ),
          }}
        ></div>
      )}
    </div>
  );
}
